import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Campagnes',
  filters: {
    search: 'Campagnes zoeken...',
  },
  columns: {
    title: 'Titel',
    created_by: 'Aangemaakt door',
    schedule_mode: 'Planmodus',
    scheduled_at: 'Gepland op',
    sent_at: 'Verzonden om',
    status: 'Status',
    sent: 'Verzonden',
    delivered: 'Bezorgd',
    delivered_rate: 'Afleveringspercentage',
    clicks: 'Klikken',
    click_rate: 'Klikpercentage',
    live: 'Live',
    actions: 'Acties',
  },
  active_status: {
    draft: 'Concept',
    active: 'Actief',
  },
  delivery: {
    in_progress: 'In afwachting van bevestiging',
    awaiting: 'In afwachting van bevestiging',
    verified: 'Geverifieerd {{relative}}',
    next_check_around: 'Volgende controle rond {{time}}',
  },
  breakdown: {
    delivered: '{{count}} bezorgd',
    pending: '{{count}} in afwachting van bevestiging',
    failed_title: 'Niet bezorgd',
    all_delivered: 'Bezorgd aan alle ontvangers.',
    load_error: 'Bezorgingsoverzicht kon niet worden geladen.',
    reasons: {
      DeviceNotRegistered: 'App verwijderd of meldingen uitgeschakeld (verlopen token)',
      MessageRateExceeded: 'Tijdelijk beperkt door Expo',
      MessageTooBig: 'Meldingspayload te groot',
      MismatchSenderId: 'Push-inloggegevens komen niet overeen',
      InvalidCredentials: 'Ongeldige push-inloggegevens',
      batch_failed: 'Batchverzending mislukt',
      missing_ticket: 'Geen bevestiging ontvangen van Expo',
      unknown: 'Onbekende bezorgfout',
    },
  },
  created_by: {
    [CreatedBy.System]: 'Systeem',
    [CreatedBy.User]: 'Gebruiker',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Direct',
    [ScheduleMode.Scheduled]: 'Gepland',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'Verzenden',
    [DeliveryStatus.Sent]: 'Verzonden',
    [DeliveryStatus.Queued]: 'In wachtrij',
    [DeliveryStatus.Failed]: 'Mislukt',
  },
  actions: {
    details: 'Details',
    view_details: 'Details bekijken',
    resend: 'Opnieuw verzenden',
    duplicate_edit: 'Dupliceren & bewerken',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    activate: 'Activeren',
    deactivate: 'Deactiveren',
  },
  success_messages: {
    campaign_updated: 'Campagne succesvol bijgewerkt',
    campaign_deleted: 'Campagne succesvol verwijderd',
  },
  error_messages: {
    failed_to_update_campaign: 'Campagne bijwerken mislukt',
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_delete_campaign: 'Campagne verwijderen mislukt',
  },
};
